import { useState } from 'react'

import { Box, Form, Text } from '@factorialco/deprecated-design-system'
import { TemplateTargetGroupDataTableDocument } from 'generated/resources/datatable.graphql'
import {
  PerformanceProcessTemplateTargetTypeFragment,
  PerformanceTemplateEditPageHeaderDocument,
  UpdatePerformanceProcessTemplateTargetStrategyDocument,
  UpdatePerformanceProcessTemplateTargetStrategyMutationVariables,
} from 'generated/resources/graphql'

import { useForm } from 'modules/core/hooks/useForm'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { TargetGroupSection } from 'modules/performance_process/components/review/forms/TargetGroup'
import { Variables } from 'modules/performance_process/components/review/forms/TargetGroup/targetEnums'

import { TemplateTargetGroupDataTable } from './TemplateTargetGroupDataTable'

export const CustomTemplateSettingsTargetGroup: React.FC<{
  template: PerformanceProcessTemplateTargetTypeFragment
}> = ({ template }) => {
  const [variables, setVariables] =
    useState<UpdatePerformanceProcessTemplateTargetStrategyMutationVariables>({
      id: template.id,
      targetStrategy: template.targetStrategy?.strategy,
      arguments: template.targetStrategy?.arguments,
    })

  const [updateReviewTargetStrategy, { loading }] = useMutation(
    UpdatePerformanceProcessTemplateTargetStrategyDocument,
    {
      extractorFn: (data) =>
        data.performanceMutations.updateTargetStrategyPerformanceReviewProcessCustomTemplate,
      refetchQueries: [
        TemplateTargetGroupDataTableDocument,
        PerformanceTemplateEditPageHeaderDocument,
      ],
    }
  )

  const handleChange = (data: Variables) => {
    setVariables({
      ...variables,
      ...data,
    })
  }

  const form = useForm<Variables>({
    defaultValues: {
      id: template.id,
      targetStrategy: template.targetStrategy?.strategy,
      arguments: template.targetStrategy?.arguments,
    },
    onSubmit: async () => {
      const response = await updateReviewTargetStrategy({
        variables,
      })

      const result = handleResult(response, () => null)
      if (result.success) {
        app.setFlash({
          type: 'correct',
          message: i18n.t('common.saved_successfully'),
        })
      }
      return result
    },
  })

  return (
    <Form padding={null}>
      <Box gap="s32">
        <Box gap="s16">
          <Text size="400" color="grey1000" weight="semibold">
            {i18n.t('performance_process.reviews.targets')}
          </Text>
          <Text size="300">
            {i18n.t('performance_process.reviews.launch_participation_modal_description')}
          </Text>
        </Box>
        <TargetGroupSection
          variables={variables}
          loading={loading}
          onChange={handleChange}
          onSubmit={form.handleSubmit}
        />
        <Box>
          <Text size="300" color="grey1000" weight="semibold">
            {i18n.t('performance_process.reviews.target_preview')}
          </Text>
          <TemplateTargetGroupDataTable templateId={template.id} />
        </Box>
      </Box>
    </Form>
  )
}
